module.exports = __webpack_public_path__ + "img/partner_19.a807ef74.png";